/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface ShipperApplicationAccessorialPolicyRequest {
  shipmentAccessorialName:
    | 'Lumper Charge'
    | 'Stop-off Charge'
    | 'Miscellaneous'
    | 'Detention Fee'
    | 'Trailer Detention Fee'
    | 'OTP/OTD Late Fee'
    | 'Driver Not Tracking Fee'
    | 'Escort Fee'
    | 'ES-Escort Service Fee'
    | 'Layover Fee'
    | 'Out of Route Miles Fee'
    | 'Circuity Fee'
    | 'Storage Fee'
    | 'Deduction Fee'
    | 'TONU'
    | 'Team Driver'
    | 'Driver Assist'
    | 'Flat Rate'
    | 'Preloading Charge'
    | 'Tier 1'
    | 'Bridge Toll'
    | 'Cross Doc'
  rate?: string
  rateType: 'flat_rate' | 'hourly' | 'daily'
  equipmentId?: number
  rateInterval?: number
  minAmount?: string
  maxAmount?: string
  minutesThreshold?: number
  approvalMinutesLimit?: number
  customerApprovalRequired?: boolean
  customerNotificationRequired?: boolean
  approvalEmail?: string
  notificationEmail?: string
  billingMethod: 'edi' | 'tms' | 'pdf' | 'mail'
  podRequired?: boolean
  receiptRequired?: boolean
  inOutTimesRequired?: boolean
  taxIdRequired?: boolean
  authNumberRequired?: boolean
  notes?: string
  isStandardRate?: boolean
}

export interface ShipperApplicationAccessorialPolicyResponse {
  id: number
  shipmentAccessorialName: string
  rate: string
  rateType?: 'flat_rate' | 'hourly' | 'daily'
  equipmentId?: number | null
  rateInterval?: number | null
  minAmount?: string | null
  maxAmount?: string | null
  minutesThreshold?: number | null
  approvalMinutesLimit?: number | null
  customerApprovalRequired?: boolean | null
  customerNotificationRequired?: boolean | null
  approvalEmail?: string | null
  notificationEmail?: string | null
  billingMethod?: 'edi' | 'tms' | 'pdf' | 'mail' | null
  podRequired?: boolean | null
  receiptRequired?: boolean | null
  inOutTimesRequired?: boolean | null
  taxIdRequired?: boolean | null
  authNumberRequired?: boolean | null
  notes?: string | null
  createdAt?: string
  updatedAt?: string
  isStandardRate?: boolean | null
}

export interface GetShipperAccessorialPoliciesResponse {
  shipperApplicationAccessorialPolicies?: ShipperApplicationAccessorialPolicyResponse[]
}

export interface GetShipperAccessorialPoliciesPathParams {
  shipperId: number
}

export type GetShipperAccessorialPoliciesProps = Omit<
  GetProps<
    GetShipperAccessorialPoliciesResponse,
    unknown,
    void,
    GetShipperAccessorialPoliciesPathParams
  >,
  'path'
> &
  GetShipperAccessorialPoliciesPathParams

/**
 * List of ShipperApplicationAccessorialPolicy
 */
export const GetShipperAccessorialPolicies = ({
  shipperId,
  ...props
}: GetShipperAccessorialPoliciesProps) => (
  <Get<
    GetShipperAccessorialPoliciesResponse,
    unknown,
    void,
    GetShipperAccessorialPoliciesPathParams
  >
    path={`v9/shippers/${shipperId}/shipper_application_accessorial_policies`}
    {...props}
  />
)

export type UseGetShipperAccessorialPoliciesProps = Omit<
  UseGetProps<
    GetShipperAccessorialPoliciesResponse,
    unknown,
    void,
    GetShipperAccessorialPoliciesPathParams
  >,
  'path'
> &
  GetShipperAccessorialPoliciesPathParams

/**
 * List of ShipperApplicationAccessorialPolicy
 */
export const useGetShipperAccessorialPolicies = ({
  shipperId,
  ...props
}: UseGetShipperAccessorialPoliciesProps) =>
  useGet<
    GetShipperAccessorialPoliciesResponse,
    unknown,
    void,
    GetShipperAccessorialPoliciesPathParams
  >(
    (paramsInPath: GetShipperAccessorialPoliciesPathParams) =>
      `v9/shippers/${paramsInPath.shipperId}/shipper_application_accessorial_policies`,
    { pathParams: { shipperId }, ...props }
  )

export interface CreateShipperAccessorialPolicyResponse {
  shipperApplicationAccessorialPolicy?: ShipperApplicationAccessorialPolicyResponse
}

export interface CreateShipperAccessorialPolicyPathParams {
  shipperId: number
}

export interface CreateShipperAccessorialPolicyRequestBody {
  shipperApplicationAccessorialPolicy?: ShipperApplicationAccessorialPolicyRequest
}

export type CreateShipperAccessorialPolicyProps = Omit<
  MutateProps<
    CreateShipperAccessorialPolicyResponse,
    unknown,
    void,
    CreateShipperAccessorialPolicyRequestBody,
    CreateShipperAccessorialPolicyPathParams
  >,
  'path' | 'verb'
> &
  CreateShipperAccessorialPolicyPathParams

/**
 * Create new ShipperApplicationAccessorialPolicy
 */
export const CreateShipperAccessorialPolicy = ({
  shipperId,
  ...props
}: CreateShipperAccessorialPolicyProps) => (
  <Mutate<
    CreateShipperAccessorialPolicyResponse,
    unknown,
    void,
    CreateShipperAccessorialPolicyRequestBody,
    CreateShipperAccessorialPolicyPathParams
  >
    verb='POST'
    path={`v9/shippers/${shipperId}/shipper_application_accessorial_policies`}
    {...props}
  />
)

export type UseCreateShipperAccessorialPolicyProps = Omit<
  UseMutateProps<
    CreateShipperAccessorialPolicyResponse,
    unknown,
    void,
    CreateShipperAccessorialPolicyRequestBody,
    CreateShipperAccessorialPolicyPathParams
  >,
  'path' | 'verb'
> &
  CreateShipperAccessorialPolicyPathParams

/**
 * Create new ShipperApplicationAccessorialPolicy
 */
export const useCreateShipperAccessorialPolicy = ({
  shipperId,
  ...props
}: UseCreateShipperAccessorialPolicyProps) =>
  useMutate<
    CreateShipperAccessorialPolicyResponse,
    unknown,
    void,
    CreateShipperAccessorialPolicyRequestBody,
    CreateShipperAccessorialPolicyPathParams
  >(
    'POST',
    (paramsInPath: CreateShipperAccessorialPolicyPathParams) =>
      `v9/shippers/${paramsInPath.shipperId}/shipper_application_accessorial_policies`,
    { pathParams: { shipperId }, ...props }
  )

export interface UpdateShipperAccessorialPolicyResponse {
  shipperApplicationAccessorialPolicy?: ShipperApplicationAccessorialPolicyResponse
}

export interface UpdateShipperAccessorialPolicyPathParams {
  shipperId: number
  id: number
}

export interface UpdateShipperAccessorialPolicyRequestBody {
  shipperApplicationAccessorialPolicy?: ShipperApplicationAccessorialPolicyRequest
}

export type UpdateShipperAccessorialPolicyProps = Omit<
  MutateProps<
    UpdateShipperAccessorialPolicyResponse,
    unknown,
    void,
    UpdateShipperAccessorialPolicyRequestBody,
    UpdateShipperAccessorialPolicyPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipperAccessorialPolicyPathParams

/**
 * Update ShipperApplicationAccessorialPolicy
 */
export const UpdateShipperAccessorialPolicy = ({
  id,
  shipperId,
  ...props
}: UpdateShipperAccessorialPolicyProps) => (
  <Mutate<
    UpdateShipperAccessorialPolicyResponse,
    unknown,
    void,
    UpdateShipperAccessorialPolicyRequestBody,
    UpdateShipperAccessorialPolicyPathParams
  >
    verb='PUT'
    path={`v9/shippers/${shipperId}/shipper_application_accessorial_policies/${id}`}
    {...props}
  />
)

export type UseUpdateShipperAccessorialPolicyProps = Omit<
  UseMutateProps<
    UpdateShipperAccessorialPolicyResponse,
    unknown,
    void,
    UpdateShipperAccessorialPolicyRequestBody,
    UpdateShipperAccessorialPolicyPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipperAccessorialPolicyPathParams

/**
 * Update ShipperApplicationAccessorialPolicy
 */
export const useUpdateShipperAccessorialPolicy = ({
  id,
  shipperId,
  ...props
}: UseUpdateShipperAccessorialPolicyProps) =>
  useMutate<
    UpdateShipperAccessorialPolicyResponse,
    unknown,
    void,
    UpdateShipperAccessorialPolicyRequestBody,
    UpdateShipperAccessorialPolicyPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipperAccessorialPolicyPathParams) =>
      `v9/shippers/${paramsInPath.shipperId}/shipper_application_accessorial_policies/${paramsInPath.id}`,
    { pathParams: { shipperId, id }, ...props }
  )

export interface DestroyShipperAccessorialPolicyPathParams {
  shipperId: number
}

export type DestroyShipperAccessorialPolicyProps = Omit<
  MutateProps<void, unknown, void, number, DestroyShipperAccessorialPolicyPathParams>,
  'path' | 'verb'
> &
  DestroyShipperAccessorialPolicyPathParams

/**
 * Delete ShipperApplicationAccessorialPolicy
 */
export const DestroyShipperAccessorialPolicy = ({
  shipperId,
  ...props
}: DestroyShipperAccessorialPolicyProps) => (
  <Mutate<void, unknown, void, number, DestroyShipperAccessorialPolicyPathParams>
    verb='DELETE'
    path={`v9/shippers/${shipperId}/shipper_application_accessorial_policies`}
    {...props}
  />
)

export type UseDestroyShipperAccessorialPolicyProps = Omit<
  UseMutateProps<void, unknown, void, number, DestroyShipperAccessorialPolicyPathParams>,
  'path' | 'verb'
> &
  DestroyShipperAccessorialPolicyPathParams

/**
 * Delete ShipperApplicationAccessorialPolicy
 */
export const useDestroyShipperAccessorialPolicy = ({
  shipperId,
  ...props
}: UseDestroyShipperAccessorialPolicyProps) =>
  useMutate<void, unknown, void, number, DestroyShipperAccessorialPolicyPathParams>(
    'DELETE',
    (paramsInPath: DestroyShipperAccessorialPolicyPathParams) =>
      `v9/shippers/${paramsInPath.shipperId}/shipper_application_accessorial_policies`,
    { pathParams: { shipperId }, ...props }
  )
